const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerQuickmenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.71 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.72px;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "power_quickmenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.77,3.16A6.56,6.56,0,0,0,.43,9.78,6.62,6.62,0,0,0,6.9,15.23,6.51,6.51,0,0,0,13,11.11,6.59,6.59,0,0,0,9.73,3.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.85,
    y1: 0.36,
    x2: 6.85,
    y2: 6.53
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerQuickmenu);
export default __webpack_public_path__ + "static/media/power_quickmenu.daad48fb3ffeb5011426a11a967c76db.svg";
export { ForwardRef as ReactComponent };